import WStepSlider from "../components/Wizard/WizardStepSlider.jsx";
import WStep10Footer from "../components/Wizard/WStep10Footer.jsx";
import WStep3Product from "../components/Wizard/WStep3Product.jsx";
import WStep4Focus from "../components/Wizard/WStep4Focus.jsx";
import WStep5Features from "../components/Wizard/WStep5Features.jsx";
import WStep6Numbers from "../components/Wizard/WStep6Numbers.jsx";
import WStep7Offers from "../components/Wizard/WStep7Offers.jsx";
import WStep8Feedback from "../components/Wizard/WStep8Feedback.jsx";
import WStep9GetInTouch from "../components/Wizard/WStep9GetInTouch.jsx";
import CheckoutSettings from "../components/Wizard/WStepECommerce/CheckoutSettings.jsx";
import DeliveryPolicy from "../components/Wizard/WStepECommerce/DeliveryPolicy.jsx";
import PaymentPaypal from "../components/Wizard/WStepECommerce/PaymentPaypal.jsx";
import PricingSettings from "../components/Wizard/WStepECommerce/PricingSettings.jsx";
import ProductOptions from "../components/Wizard/WStepECommerce/ProductOptions.jsx";
import ProductPictures from "../components/Wizard/WStepECommerce/ProductPictures.jsx";
import ReturnPolicy from "../components/Wizard/WStepECommerce/ReturnPolicy.jsx";
import WStepEmbed from "../components/Wizard/WStepEmbed.jsx";
import WStepSteps from "../components/Wizard/WStepSteps.jsx";
import WStepVideo from "../components/Wizard/WStepVideo.jsx";

export const PartListDefault = [
    {
        name: "",
        key: "product",
        component: WStep3Product,
        menuKey: "WizardMobileMenuProduct",
        requires: ["ProductName", "ProductDescription"],
    },

    // Basic || ECommerce
    {
        name: "BlockHeader",
        key: "focus",
        component: WStep4Focus,
        menuKey: "WizardMobileMenuFocus",
        requires: ["Stimulus", "Actions", "ProductPicture"],
    },
    {
        name: "BlockHeaderECommerce",
        key: "focus",
        component: WStep4Focus,
        menuKey: "WizardMobileMenuFocus",
        requires: ["Stimulus", "Actions", "PhotosNVideos"],
    },

    {
        name: "BlockFeatures",
        key: "features",
        component: WStep5Features,
        menuKey: "WizardMobileMenuFeatures",
        requires: ["Features"],
    },
    {
        name: "BlockSlider",
        key: "slider",
        component: WStepSlider,
        menuKey: "WizardMobileMenuSlider",
        requires: ["Slider"],
    },
    { name: "BlockSteps", key: "steps", component: WStepSteps, menuKey: "WizardMobileMenuSteps", requires: ["Steps"] },
    { name: "BlockEmbed", key: "embed", component: WStepEmbed, menuKey: "WizardMobileMenuEmbed", requires: ["Embed"] },
    { name: "BlockVideo", key: "video", component: WStepVideo, menuKey: "WizardMobileMenuVideo", requires: ["Video"] },
    {
        name: "BlockNumbers",
        key: "numbers",
        component: WStep6Numbers,
        menuKey: "WizardMobileMenuNumbers",
        requires: ["Numbers"],
    },
    {
        name: "BlockOffers",
        key: "offers",
        component: WStep7Offers,
        menuKey: "WizardMobileMenuOffers",
        requires: ["PaymentType", "Offers"],
    },
    {
        name: "BlockFeedbacks",
        key: "feedback",
        component: WStep8Feedback,
        menuKey: "WizardMobileMenuFeedback",
        requires: ["Feedbacks"],
    },
    {
        name: "BlockGetInTouch",
        key: "get-in-touch",
        component: WStep9GetInTouch,
        menuKey: "WizardMobileMenuCTA",
        requires: ["GetInTouch"],
    },
    {
        name: "BlockFooter",
        key: "footer",
        component: WStep10Footer,
        menuKey: "WizardMobileMenuFooter",
        requires: ["Legacy"],
        isLast: true,
    },
    // { name: "", key: null, component: null },
];

export const PartListECommerce = [
    {
        name: "",
        key: "paypal-settings",
        component: PaymentPaypal,
        menuKey: "WizardMenuPayPalSettings",
        requires: ["PaymentSystem"],
    },
    {
        name: "",
        key: "pricing-settings",
        component: PricingSettings,
        menuKey: "WizardMenuPricingSettings",
        requires: ["Pricing"],
    },
    {
        name: "",
        key: "checkout-settings",
        component: CheckoutSettings,
        menuKey: "WizardMenuCheckoutSettings",
        requires: ["Checkout"],
    },
    {
        name: "",
        key: "product-pictures",
        component: ProductPictures,
        menuKey: "WizardMenuProductPicturesSettings",
        requires: ["PhotosNVideos"],
    },
    {
        name: "",
        key: "product-options",
        component: ProductOptions,
        menuKey: "WizardMenuProductOptionsSettings",
        requires: ["ProductOptions"],
    },
    {
        name: "",
        key: "return-policy",
        component: ReturnPolicy,
        menuKey: "WizardMenuReturnPolicySettings",
        requires: ["ReturnPolicy"],
    },
    {
        name: "",
        key: "delivery-policy",
        component: DeliveryPolicy,
        menuKey: "WizardMenuDeliveryPolicySettings",
        requires: ["DeliveryPolicy"],
    },
];

export const useGetPartList = (props = {}) => {
    const { type, structure } = props;

    if (type === "ecommerce") {
        return PartListECommerce;
    }

    if (type === "content" || !structure) {
        return PartListDefault;
    }

    const PartList = [];

    PartList.push(PartListDefault[0]);

    structure.forEach((item, index) => {
        for (const part of PartListDefault) {
            if (part.name === item.name) {
                PartList.push({ ...part, key: `${item.name}-${index}`, variables2block: { ...item } });
            }
        }
    });

    return PartList;
};
